export default [
    {
        id : 1,
        name : 'HTML5',
        img : 'https://cdn-icons-png.flaticon.com/128/174/174854.png',
        type : 'languages'
    },
    {
        id : 2,
        name : 'CSS3',
        img : 'https://cdn-icons-png.flaticon.com/128/732/732190.png',
        type : 'languages'
    },
    {
        id : 3,
        name : 'Javascript',
        img : 'https://cdn-icons-png.flaticon.com/128/5968/5968292.png',
        type : 'languages'
    },
    {
        id : 4,
        name : 'Php',
        img : 'https://cdn-icons-png.flaticon.com/128/919/919830.png',
        type : 'languages'
    },
    {
        id : 5,
        name : 'Sql',
        img : 'https://cdn-icons-png.flaticon.com/128/2306/2306173.png',
        type : 'languages'
    },
    {
        id : 6,
        name : 'Python',
        img : 'https://cdn-icons-png.flaticon.com/128/5968/5968350.png',
        type : 'languages'
    },
    {
        id : 7,
        name : 'Mysql',
        img : 'https://cdn-icons-png.flaticon.com/128/5968/5968313.png',
        type : 'databases'
    },
    {
        id : 8,
        name : 'NoSql',
        img : 'https://cdn-icons-png.flaticon.com/128/8452/8452873.png',
        type : 'databases'
    },
    {
        id : 9,
        name : 'MongoDb',
        img : 'https://viget.imgix.net/mongo-logo.png?auto=format%2Ccompress&crop=focalpoint&fit=crop&fp-x=0.5&fp-y=0.5&h=1280&ixlib=php-2.1.1&q=90&w=1280&s=a153c7c80f42ab1e7db7fd2b6a27ab3b',
        type : 'databases'
    },
    {
        id : 10,
        name : 'UML',
        img : 'https://cdn-icons-png.flaticon.com/128/3665/3665975.png',
        type : 'databases'
    },
    {
        id : 11,
        name : 'React Js',
        img : 'https://cdn-icons-png.flaticon.com/128/1126/1126012.png',
        type : 'framework'
    },
    {
        id : 12,
        name : 'Node Js',
        img : 'https://static-00.iconduck.com/assets.00/node-js-icon-227x256-913nazt0.png',
        type : 'framework'
    },
    {
        id : 13,
        name : 'Laravel',
        img : 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Laravel.svg/985px-Laravel.svg.png',
        type : 'framework'
    },
    {
        id : 14,
        name : 'Sass',
        img : 'https://cdn-icons-png.flaticon.com/128/5968/5968358.png',
        type : 'framework'
    },
    {
        id : 15,
        name : 'Material Ui',
        img : 'https://mui.com/static/logo.png',
        type : 'framework'
    },
    {
        id : 16,
        name : 'Bootstrap',
        img : 'https://cdn-icons-png.flaticon.com/128/5968/5968672.png',
        type : 'framework'
    },
    {
        id : 17,
        name : 'Ui / UX',
        img : 'https://cdn-icons-png.flaticon.com/128/1541/1541399.png',
        type : 'additional'
    },
    {
        id : 18,
        name : 'Git',
        img : 'https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png',
        type : 'additional'
    },
    {
        id : 19,
        name : 'Agile',
        img : 'https://cdn-icons-png.flaticon.com/128/2621/2621327.png',
        type : 'additional'
    },
    {
        id : 20,
        name : 'Jira',
        img : 'https://cdn.icon-icons.com/icons2/2699/PNG/512/atlassian_jira_logo_icon_170511.png',
        type : 'additional'
    },
    {
        id : 21,
        name : 'Sonarqube',
        img : 'https://cdn.worldvectorlogo.com/logos/sonarqube-1.svg',
        type : 'additional'
    },
    {
        id : 22,
        name : 'Adobe XD',
        img : 'https://cdn-icons-png.flaticon.com/128/5611/5611129.png',
        type : 'additional'
    }
]